export default __webpack_public_path__ + "static/media/speaker.750ff8d5.png";